import { ViewDescription } from '@debbie/common/dist/views/index.js'
import { atomWithStorage } from 'jotai/utils'

export const viewPatches = atomWithStorage<{
  [key: string]: ViewDescription | undefined
}>('view-patches', {})
